export default "__VITE_ASSET__DfAHowBQ__"